<template>

    <div>


        <div class="scroll-comments" v-if="comments.length">
            <section
                    class="event"
                    v-for="comment in comments"
            >

                <ul class="post-comments mt-sm">

                    <li
                            v-bind:class="{ 'selected-comment': comment.id === selectedId }">
                    <span class="thumb-xs avatar pull-left mr-sm">
                       <a @click="$router.push('/users/' + comment.uid)">
                        <img class="rounded-circle" :src="comment.profilePicture" alt="..."/>
                       </a>
                    </span>
                        <div class="comment-body">
                            <h6 class="author fs-sm fw-semi-bold">
                                <a @click="$router.push('/users/' + comment.uid)">{{comment.fullName}}</a>
                                <small>
                                    <timeago :datetime="comment.createdOn |unixToDate" :auto-update="60"></timeago>
                                </small>
                            </h6>
                            <p>{{comment.text}}</p>
                        </div>
                    </li>

                    <li
                            v-for="child in  comment.childs"
                            class="indent-child"
                            v-bind:class="{ 'selected-comment': child.id === selectedId }"

                    >
                            <span class="thumb-xs avatar pull-left mr-sm">
                                <a @click="$router.push('/users/' + child.uid)">
                                    <img class="rounded-circle" :src="child.profilePicture" alt="..."/>
                                </a>
                            </span>
                        <div class="comment-body">

                            <h6 class="author fs-sm fw-semi-bold">
                                <a @click="$router.push('/users/' + child.uid)">{{child.fullName}}</a>
                                <small>
                                    <timeago :datetime="child.createdOn |unixToDate" :auto-update="60"></timeago>
                                </small>
                            </h6>
                            <p>{{child.text}}</p>
                        </div>
                    </li>


                    <li class="indent-child" v-if="!parentId">
                    <span class="thumb-xs avatar pull-left mr-sm">
                        <img class="rounded-circle" :src="currentUserProfile.profilePicture" alt="..."/>
                    </span>
                        <div class="comment-body">
                            <b-form-input
                                    :data-id="comment.id"
                                    v-model="comment.writeReply"
                                    class="form-control form-control-sm"
                                    type="text"
                                    placeholder="Write a reply ..."
                                    @keyup.native="maybeSaveComment"/>
                        </div>
                    </li>
                </ul>
            </section>


        </div>

        <b-form class="mt">
            <ul class="post-comments mt-sm">
                <li>
                    <span class="thumb-xs avatar pull-left mr-sm">
                        <img class="rounded-circle" :src="currentUserProfile.profilePicture" alt="..."/>
                    </span>
                    <div class="comment-body">
                        <textarea-autosize
                                v-model="parentComment"
                                placeholder="Write a comment" :rows="3"
                                class="form-control"
                                id="new-event"
                                style="min-height:50px"
                        />
                        <b-button variant="success" :disabled="parentComment.length <= 2" size="sm" type="submit" @click.prevent="addParentComment" class="btn ml-auto">Post</b-button>

                    </div>
                </li>
            </ul>

            <!--            <b-form-group class="mb-2">-->
            <!--                <Label class="sr-only" for="new-event">New event</Label>-->

            <!--            </b-form-group>-->
            <div class="btn-toolbar">
                <!--                <div class="btn-group">-->
                <!--                    <a href="#" class="btn btn-sm btn-default">-->
                <!--                        <i class="fa fa-camera fa-lg"/>-->
                <!--                    </a>-->
                <!--                    <a href="#" class="btn width-100 mb-xs mr-xs btn-outline-success">-->
                <!--                        <i class="fa fa-map-marker fa-lg"/>-->
                <!--                    </a>-->
                <!--                    <a href="#" class="btn width-100 mb-xs mr-xs btn-outline-danger">-->
                <!--                        <span class=""><i class="fa fa-heart-o"/> Like</span>-->
                <!--                    </a>-->
                <!--                </div>-->
            </div>
        </b-form>
    </div>
</template>


<script>
  const fb        = require('@/firebaseConfig.js')
  const CommonLib = require('@/lib/Common')

  import Vue from 'vue'
  import Moment from 'moment'
  import VueTimeago from 'vue-timeago'
  import Likes from '@/components/Likes/Likes'
  import Post from '@/components/Posts/Post'
  import TextPost from '@/components/Posts/Types/TextPostType'
  import UIHelpersMixins from '@/mixims/UIHelpersMixins'

  export default {
    name:       'CommentsThread',
    components: {
      Likes,
      TextPost,
    },
    mixins:
                [
                  UIHelpersMixins,
                ],
    props:      [
      'threadId',
      'selectedId',
      'threadCollection'
    ],
    data ()
    {
      return {
        comments:      [],
        parentComment: '',
        parentId:      null,
        writeReply:    [],
      }
    },
    mounted ()
    {
      this.reload()
    },

    computed: {

      currentUserProfile ()
      {
        return this.$store.getters.currentUserProfile

      },
      currentUser ()
      {
        return this.$store.getters.currentUser
      },

    },
    methods:  {
      addParentComment ()
      {
        var that           = this
        let parentComment  = this.parentComment
        this.parentComment = ''

        var parentId = null
        if (this.parentId)
        {
          parentId = this.parentId
        }

        fb.commentsCollection.add({
          createdOn: new Date(),
          updatedOn: new Date(),

          uid:      this.currentUser.uid,
          threadId: this.threadId,
          parent:   parentId,
          text:     parentComment,

        }).then(ref => {

          that.addActivity(ref)
          that.$emit('parent-comment-added', ref)

        }).catch(err => {
          console.log(err)
        })
      },

      reload ()
      {
        var that = this

        var ref = fb.commentsCollection

        /*  if (this.showId)
          {
            ref = ref.where('parent', '==', this.parentId)
          } else*/
        if (this.threadId)
        {
          ref = ref.where('threadId', '==', this.threadId)
        } else
        {
          return
        }

        ref.orderBy('createdOn', 'asc')
          .onSnapshot(function (querySnapshot) {

            var comments = []

            var uids = []
            querySnapshot.forEach(function (doc) {

              var comment = doc.data()
              comment.id  = doc.id

              uids.push(comment.uid)

              comments.push(comment)
            })

            var parents = []
            comments.forEach(function (comment) {

              if ((that.parentId && comment.parent === that.parentId) || comment.parent === null)
              {
                comment.childs = that.findChilds(comments, comment.id)

                parents.push(comment)

              }

            }) // forEach

            that.$store.dispatch('userProfiles/retreiveProfiles', uids).then(function (userProfiles) {

              parents.forEach(function (comment) {
                that.addProfileInfo(userProfiles, comment)
                comment.childs.forEach(function (child) {
                  that.addProfileInfo(userProfiles, child)
                })
              })

              that.comments = parents

            }).catch(function (err) {
              console.log(err)
            })

          }) // snapshot

      },
      findChilds (comments, parentId)
      {
        var childs = []

        comments.forEach(function (comment) {
          if (comment.parent === parentId)
          {
            childs.push(comment)
          }
        })

        return childs
      },
      addProfileInfo (userProfiles, comment)
      {
        var userProfile = userProfiles.find(profile => profile.uid === comment.uid)

        comment.fullName       = userProfile.fullName
        comment.profilePicture = userProfile.profilePicture
        return comment
      },
      maybeSaveComment (e, id)
      {
        var targetId = e.currentTarget.dataset.id

        var comment = this.comments.find(comment => comment.id === targetId)

        if (e.keyCode !== 13 || !comment.writeReply.length)
        {
          return
        }

        this.addComment(targetId, comment)

      },
      addComment (parentId, comment)
      {
        var that           = this
        let writeReply     = comment.writeReply
        comment.writeReply = ''

        fb.commentsCollection.add({
          createdOn: new Date(),
          updatedOn: new Date(),

          uid:      this.currentUser.uid,
          threadId: comment.threadId,
          parent:   parentId,
          text:     writeReply,

        }).then(ref => {
          that.$emit('child-comment-added', ref)

          that.addActivity(ref)

        }).catch(err => {
          console.log(err)
        })
      },
      addActivity (ref)
      {
        var that = this
        fb.activityCollection.add({
          createdOn: new Date(),
          updatedOn: new Date(),
          uid:       this.currentUser.uid,

          action:   that.threadCollection + '_comment_added',
          contents: {
            commentId: ref.id,
          },

          source: {
            url:        this.$router.currentRoute.path,
            id:         that.threadId,
            collection: that.threadCollection,
          }
        })

      }
    },
    watch:    {
      threadId ()
      {
        this.reload()
      }
    }
  }

</script>
<style src="@/pages/Profile/Profile.scss" lang="scss" scoped/>


<style>

    .selected-comment {
        background-color: #ffd !important;
    }

    .indent-child {
        padding-left: 30px !important;

    }

    .scroll-comments {
        overflow-y: scroll;
        max-height: 450px;
    }


</style>
